import { Components, stepIconClasses, svgIconClasses, Theme } from "@mui/material";

export const MuiStepLabel: Components<Omit<Theme, "MuiStepLabel">>["MuiStepLabel"] =
  {
    styleOverrides: {
      root: {
        padding: "4px 0",
      },
      label: {
        fontSize: 16,
        lineHeight: "19.2px",
      },
      iconContainer: ({ theme: { palette } }) => ({
        paddingRight: 24,
        [`& .${stepIconClasses.root}`]: {
          fill: palette.custom.purple[50],
        },
        [`& .${stepIconClasses.text}`]: {
          fill: palette.custom.purple[400],
        },
        [`& .${svgIconClasses.root}`]: {
          fontSize: 32,
        },
      }),
    },
  };
